export default "__VITE_ASSET__DJGcVoBv__"